import AdminTable from 'layouts/AdminTable';
import DataGridStateContextProvider from 'components/DataGrid/DataGridStateContext';
import { useTranslation } from 'react-i18next';
import NavTabs from 'components/NavTabs/NavTabs';
import { makeStyles } from '@material-ui/styles';
import { grayColor } from 'assets/jss/material-dashboard-pro-react';
import { useHistory } from 'react-router';
import { useEffect } from 'react';

import EcommerceBagCurrent from './EcommerceBagCurrent/EcommerceBagCurrent';
import EcommerceBagHistory from './EcommerceBagHistory/EcommerceBagHistory';

const useStyles = makeStyles(() => ({
  customTabs: {
    backgroundColor: grayColor[8],
    marginTop: '24px',
    marginBottom: '8px',
  },
}));

const EcommerceBagList = () => {
  const { t } = useTranslation();
  const classes = useStyles();
  const history = useHistory();

  const url = new URL(window.location.href);

  const handleTabChange = () => {
    url.searchParams.delete('filter');
    history.replace({ search: url.search });
  };

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.has('filter')) {
      params.delete('filter');
      history.replace({
        search: params.toString(),
      });
    }
    // eslint-disable-next-line
  }, []);

  return (
    <DataGridStateContextProvider>
      <AdminTable title={t('ecommerceBags.name')}>
        <NavTabs
          classes={{ tabs: classes.customTabs }}
          tabs={[
            {
              tabButton: t('ecommerceBags.navTitleCurrent'),
              tabContent: <EcommerceBagCurrent />,
            },
            {
              tabButton: t('ecommerceBags.navTitleHistory'),
              tabContent: <EcommerceBagHistory />,
            },
          ]}
          onChange={handleTabChange}
        />
      </AdminTable>
    </DataGridStateContextProvider>
  );
};

export default EcommerceBagList;
